import { getModifiedSetting } from '@/js/DeviceSetting';
import {
  portDetailFormatted,
  modbusSlaveFormatted,
  isModbusGateway,
} from '@/js/utils';

const portsData = (state) => (uid) =>
  state.portsData.find(
    (ports) =>
      ports.dev_id === uid ||
      ports.mac_addr === uid ||
      ports.dev_client_id === uid
  );

const settingItem = (state) => {
  return state.configData;
};

const fetchedPortsData = (state) => {
  return state.portsData.map((el) => el.dev_id);
};

const portsLogLink = (state) => (uid) => {
  return state.portsLogLink[uid];
};

const settingData = (state) => {
  return state.settingData;
};

const settingTarget = (state) => {
  return state.settingTarget;
};

const settingView = (state) => {
  return state.settingView;
};

const settingPopup = (state) => {
  return state.settingPopup;
};

const tobeSavedSetting = (state) => {
  return getModifiedSetting(state.settingData, state.settingOriginal);
};

const highlightList = (state) => {
  return state.highlightList;
};

const modbusSlaveAll = (state) => (uid) => {
  const dev = state.portsData.find(
    (ports) =>
      ports.dev_id === uid ||
      ports.mac_addr === uid ||
      ports.dev_client_id === uid
  );
  if (dev && dev.ports) return dev.ports;
};

const modbusSlaveDetail = (state) => (portId) => {
  if (!portId) return;
  let res;
  state.portsData.find((p) => {
    if (!Array.isArray(p.ports)) return;
    const slave = p.ports.find((slave) => slave.port_id === portId);
    if (slave) {
      res = {
        dev_id: p.dev_id,
        dev_model: p.dev_model,
        mac_addr: p.mac_addr,
        dev_desc: p.dev_desc,
        ...modbusSlaveFormatted(slave),
      };
      return true;
    }
  });
  if (res) {
    return res;
  } else {
    const sharedSlave = state.sharedPortData.find(
      (slave) => slave.port_id === portId
    );
    if (sharedSlave) {
      return {
        dev_id: sharedSlave.dev_id,
        dev_model: sharedSlave.dev_model,
        mac_addr: sharedSlave.mac_addr,
        dev_desc: sharedSlave.dev_desc,
        ...modbusSlaveFormatted(sharedSlave),
      };
    }
  }
};

const historyData = (state) => (devId, date) => {
  if (!devId || !state.historyData[devId]) return;

  return state.historyData[devId][date];
};

const sharedPortList = (state) => state.sharedPortData;

const sharedSlaveList = (state) => state.sharedSlaveData;

const pendingValidation = (state) => state.pendingValidation;

const portDetail = (state) => (portId) => {
  if (!portId) return;
  const myPort = state.portsData.find(
    (p) =>
      Array.isArray(p.ports) && p.ports.find((port) => port.port_id === portId)
  );
  if (myPort) {
    return portDetailFormatted({
      ...myPort,
      ...myPort.ports.find((port) => port.port_id === portId),
    });
  } else {
    const sharedPort = state.sharedPortData.find(
      (port) => port.port_id === portId
    );
    if (sharedPort) {
      if (isModbusGateway(sharedPort.dev_model)) {
        return modbusSlaveFormatted(sharedPort);
      }
      return portDetailFormatted(sharedPort);
    }
  }
};

export default {
  portsData,
  portsLogLink,
  settingItem,
  settingData,
  tobeSavedSetting,
  settingTarget,
  fetchedPortsData,
  highlightList,
  settingPopup,
  settingView,
  sharedPortList,
  sharedSlaveList,
  portDetail,
  modbusSlaveAll,
  modbusSlaveDetail,
  historyData,
  pendingValidation,
};
